module.exports = __webpack_public_path__ + "static/media/AllowMedia.54d2c140.svg";